import React, { useEffect } from 'react';
import { useVendorCtx } from 'shared/state/configContexts';

/**
 * Theme selection lives on <html> so Radix portals (which mount on <body>)
 * inherit the same tokens — this replaces the classic shell's body-class hack.
 */
export function ThemeProvider({ theme = 'dark', children }: { theme?: 'dark' | 'light'; children: React.ReactNode }) {
  const { vendor } = useVendorCtx();
  useEffect(() => {
    const root = document.documentElement;
    root.dataset.vendor = vendor.id.toLowerCase();
    root.dataset.theme = theme;
    // The shadcn `.dark` palette (src/index.css) belongs to this shell only:
    // classic renders the light one, as production does, so the class comes off
    // with the shell (src/test/darkPalette.test.js).
    root.classList.add('dark');
    return () => { delete root.dataset.vendor; delete root.dataset.theme; root.classList.remove('dark'); };
  }, [vendor.id, theme]);
  return <>{children}</>;
}
